import { render, staticRenderFns } from "./addQuestionnaire.vue?vue&type=template&id=b67738ec"
import script from "./addQuestionnaire.vue?vue&type=script&lang=js"
export * from "./addQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports